import utils from "../utils";
import Cookie from "js-cookie";
import constants from "../values/constants";
import errorHandler from "../utils/errorHandler";

import axios, {AxiosResponse} from "axios";

const imageFileAxios = axios.create({
  baseURL: constants.BASE_URL_FILE,
  headers: {
    authorization: `Bearer ${Cookie.get(constants.USER.TOKEN)}`,
    accept: `application/json`,
    type: `${utils.stringHexConversion.reverse(Cookie.get(constants.USER.TYPE))}`,
  },
});

imageFileAxios.interceptors.response.use(
  function (response: AxiosResponse<any, any>) {
    return response;
  },
  // ?? ===============================================================================================================
  // ?? This function is depends on BACK-END status codes =============================================================
  function (error: any) {
    if (error?.response?.status === constants.CODE_LOGOUT_USER) return utils.cookiesValue.remove();
    errorHandler(error?.response?.data?.CODE ? error.response.data.CODE : error.response.data.statusCode);
    return false;
  }
);

export default imageFileAxios;
